import React from "react";
import { Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import Signin from "./pages/Signin";
import Test from "./pages/sample/test";
import Signup from "./pages/Signup/Signup";
import Becomeaninstructor from "./pages/become-an-instructor";
import Thankyou from "./pages/thankyoupage";
import About from "./pages/aboutpage";
import Blog from "./pages/blog";
import Readmoreblog from "./pages/readblog";
import Faqspage from "./pages/faqs";
import Termsandconditionspage from "./pages/termsandconditions";
import Policypage from "./pages/policy";
import Forgotpassword from "./pages/Signup/forgot-password";
import Varificationotp from "./pages/Signup/Varificationotp";
import Changepassword from "./pages/Signup/Changepassword";
import Verification from "./pages/Signup/Verification";
import Registration from "./pages/Signup/Registration";
import PageNotFound from "./pages/PageNotFound";
import Test2 from "./pages/sample/test2";
import Test3 from "./pages/sample/test3";
import Test4 from "./pages/sample/test4";
import Test5 from "./pages/sample/test5";
import Loader from "./pages/sample/loader";
import spinner from "./pages/sample/spinner";
import Coursecontent from "./pages/Learner/Coursecontent";
import Courseheader from "./pages/Learner/Courseheader";
import DataScience from "./pages/course/post-graduate-program-in-data-science";
import DataEng from "./pages/course/post-graduate-program-in-data-engineering";
import DataAnalytics from "./pages/course/post-graduate-program-in-data-analytics";
import Machinelearning from "./pages/course/online-machine-learning-course";
import Machinelearningpy from "./pages/course/certificate-course-in-machine-learning-using-python";
import Executivesix from "./pages/course/executive-overview-six-sigma-program";
import Leansix from "./pages/course/lean-six-sigma-supplement";
import Masterblack from "./pages/course/six-sigma-master-black-belt-certification-program";
import Greensix from "./pages/course/six-sigma-green-belt-certification-online";
import Yellowsix from "./pages/course/six-sigma-yellow-belt-program";
import Blacksix from "./pages/course/six-sigma-black-belt-certification-program";
import Valuation from "./pages/course/valuation";
import Financial from "./pages/course/financial-statements-analysis-course";
import Insolvency from "./pages/course/insolvency-and-bankruptcy-code";
import Certificateinsql from "./pages/course/certificate-course-in-sql";
import Certificateinmongodb from "./pages/course/certificate-course-in-mongodb";
import Certificateinbigdatahadoop from "./pages/course/certificate-course-in-big-data-hadoop";
import Certificateinpython from "./pages/course/certificate-course-in-python-programming";
import Certificateinspark from "./pages/course/certificate-course-in-spark";
import Certificateincloudcomputing from "./pages/course/certificate-course-in-cloud-computing";
import Certificateinrprograming from "./pages/course/certificate-course-in-data-analytics-using-r-programing";
import Certificateinadvanceexcel from "./pages/course/certificate-course-in-advance-excel";
import Certificateusingpowerbi from "./pages/course/certificate-course-in-data-visualizaton-using-power-bi";
import Certificateusintableau from "./pages/course/certificate-course-in-data-visualiztion-using-tableau";
import Certificateusintensorflow from "./pages/course/certificate-course-in-deep-learning-using-tensorflow";
import Certificateusincybercrime from "./pages/course/certificate-in-cyber-crime-analysis";
import Onlinesybersecuritycertification from "./pages/course/online-cyber-security-certification";
import Statisticsforresearcherscourse from "./pages/course/statistics-for-researchers-course";
import Signalprocessingusingmatlab from "./pages/course/signal-processing-using-matlab";
import profile from "./pages/Learner/learnerprofile/profile";
import Transactionpage from "./pages/Learner/learnerprofile/transaction";
import myskill from "./pages/Learner/learnerprofile/myskill";
import mycertificate from "./pages/Learner/learnerprofile/mycertificate";
import mygradesheet from "./pages/Learner/learnerprofile/mygradesheet";
import Opportunities from "./pages/Learner/learnerprofile/Opportunities";
import Linkedinjobs from "./pages/Learner/learnerprofile/linkedinjobs";
import Helpdesk from "./pages/Learner/learnerprofile/helpdesk";
import Uploaddocument from "./pages/Learner/learnerprofile/uploaddocument";

import Explore from "./pages/Learner/Explore";
import HelpVideotab from "./pages/Learner/HelpVideotab";
import ExploreCoursepage from "./pages/Learner/ExploreCourse";
import Changepasswordpage from "./pages/Learner/learnerprofile/changepswd";

//paymnet
// import Payment from "./pages/payment/Payment";
import PaymentSuccess from "./pages/payment/PaymentSuccess";
import PaymentFailure from "./pages/payment/PaymentFailure";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Installement from "./pages/Learner/Installement";
// import Notification from "./pages/Learner/Notification";


import { UserContext } from "./context/UserContext";
const Routes = (props) => {
  return (
    <div>
      <Header/>
      <Switch>
      <Route exact path="/signin" component={Signin} />
        <Route exact path="/" component={Home} />
      
        <Route exact path="/test" component={Test} />
        <Route
          exact
          path="/become-an-instructor"
          component={Becomeaninstructor}
        />
        <Route exact path="/thankyoupage" component={Thankyou} />
        <Route exact path="/aboutpage" component={About} />
        <Route exact path="/blog" component={Blog} />
        <Route exact path="/blog/:pathname" component={Readmoreblog} />
        <Route exact path="/faqs" component={Faqspage} />
        <Route
          exact
          path="/termsandconditions"
          component={Termsandconditionspage}
        />
        <Route exact path="/policy" component={Policypage} />
        <Route exact path="/Signup" component={Signup} />
        <Route exact path="/forgot-password" component={Forgotpassword} />
        <Route exact path="/Varificationotp" component={Varificationotp} />
        <Route exact path="/Changepassword" component={Changepassword} />
        <Route exact path="/Registration" component={Registration} />
        <Route exact path="/Verification" component={Verification} />
        <Route exact path="/Learner/:name" component={Courseheader} />
        <Route
          exact
          path="/Learner/:name/course-content"
          component={Coursecontent}
        />
        <Route exact path="/test2" component={Test2} />
        <Route exact path="/test3" component={Test3} />
        <Route exact path="/test4" component={Test4} />
        <Route exact path="/test5" component={Test5} />
        <Route exact path="/loader" component={Loader} />
        <Route exact path="/spinner" component={spinner} />
        <Route
          exact
          path="/course/post-graduate-program-in-data-science"
          component={DataScience}
        />
        <Route
          exact
          path="/course/post-graduate-program-in-data-engineering"
          component={DataEng}
        />
        <Route
          exact
          path="/course/post-graduate-program-in-data-analytics"
          component={DataAnalytics}
        />
        <Route
          exact
          path="/course/online-machine-learning-course"
          component={Machinelearning}
        />
        <Route
          exact
          path="/course/certificate-course-in-machine-learning-using-python"
          component={Machinelearningpy}
        />
        <Route
          exact
          path="/course/executive-overview-six-sigma-program"
          component={Executivesix}
        />
        <Route
          exact
          path="/course/lean-six-sigma-supplement"
          component={Leansix}
        />
        <Route
          exact
          path="/course/six-sigma-master-black-belt-certification-program"
          component={Masterblack}
        />
        <Route
          exact
          path="/course/six-sigma-green-belt-certification-online"
          component={Greensix}
        />
        <Route
          exact
          path="/course/six-sigma-yellow-belt-program"
          component={Yellowsix}
        />
        <Route
          exact
          path="/course/six-sigma-black-belt-certification-program"
          component={Blacksix}
        />
        <Route exact path="/course/valuation" component={Valuation} />
        <Route
          exact
          path="/course/financial-statements-analysis-course"
          component={Financial}
        />
        <Route
          exact
          path="/course/insolvency-and-bankruptcy-code"
          component={Insolvency}
        />
        <Route
          exact
          path="/course/certificate-course-in-sql"
          component={Certificateinsql}
        />
        <Route
          exact
          path="/course/certificate-course-in-mongodb"
          component={Certificateinmongodb}
        />
        <Route
          exact
          path="/course/certificate-course-in-big-data-hadoop"
          component={Certificateinbigdatahadoop}
        />
        <Route
          exact
          path="/course/certificate-course-in-python-programming"
          component={Certificateinpython}
        />
        <Route
          exact
          path="/course/certificate-course-in-spark"
          component={Certificateinspark}
        />
        <Route
          exact
          path="/course/certificate-course-in-cloud-computing"
          component={Certificateincloudcomputing}
        />
        <Route
          exact
          path="/course/certificate-course-in-data-analytics-using-r-programing"
          component={Certificateinrprograming}
        />
        <Route
          exact
          path="/course/certificate-course-in-advance-excel"
          component={Certificateinadvanceexcel}
        />
        <Route
          exact
          path="/course/certificate-course-in-data-visualizaton-using-power-bi"
          component={Certificateusingpowerbi}
        />
        <Route
          exact
          path="/course/certificate-course-in-data-visualiztion-using-tableau"
          component={Certificateusintableau}
        />
        <Route
          exact
          path="/course/certificate-course-in-deep-learning-using-tensorflow"
          component={Certificateusintensorflow}
        />
        <Route
          exact
          path="/course/certificate-in-cyber-crime-analysis"
          component={Certificateusincybercrime}
        />
        <Route
          exact
          path="/course/online-cyber-security-certification"
          component={Onlinesybersecuritycertification}
        />
        <Route
          exact
          path="/course/statistics-for-researchers-course"
          component={Statisticsforresearcherscourse}
        />
        <Route
          exact
          path="/course/signal-processing-using-matlab"
          component={Signalprocessingusingmatlab}
        />
        <Route exact path="/profile" component={profile} />
        <Route exact path="/transaction" component={Transactionpage} />
        <Route exact path="/myskill" component={myskill} />
        <Route exact path="/mycertificate" component={mycertificate} />
        <Route exact path="/mygradesheet" component={mygradesheet} />
        
        <Route exact path="/Opportunities" component={Opportunities} />
        <Route exact path="/linkedinjobs" component={Linkedinjobs} />
        <Route exact path="/helpdesk" component={Helpdesk} />
        <Route exact path="/uploaddocument" component={Uploaddocument} />
        <Route exact path="/changepswd" component={Changepasswordpage} />

        <Route exact path="/Explore" component={Explore} />
        <Route exact path="/HelpVideotab" component={HelpVideotab} />
        <Route exact path="/Explore/:pathname" component={ExploreCoursepage} />

        {/* <Route exact path="/Payment/:pathname" component={Payment} /> */}
        <Route exact path="/transactionreceipt" component={PaymentSuccess} />
        <Route exact path="/pay-installment" component={Installement} />
        <Route
          exact
          path="/transactionfailure/order"
          component={PaymentFailure}
        />
        <Route exact path="/transactionfailure" component={PaymentFailure} />
        {/* <Route exact path="/Learner/notification/view-all" component={Notification} /> */}
        <Route path="/Course/:name" component={Test} />
        <Route exact path="*" component={PageNotFound} />
      </Switch>
      <Footer />
      {/* </>} */}
    </div>
  );
};

export default Routes;
